import PropTypes from 'prop-types';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { isLocked } from 'shared/utils';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    Card,
    InfoCard,
    PieChart,
    Table
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import { TABLE, downloadHeaders } from './fixtures';
import {
    useDispatch,
    useSelector
} from 'hooks';

const LicensesSummary = ({
    tabController
}) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { user } = useSelector('account');
    const {
        configurations: {
            licenses: licensesConfig
        }
    } = useSelector('config');
    const {
        licenses,
        licensesDownload,
        licensesDownloading,
        licensesSummary = {},
        loading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsLicenses(filters));
    };

    const {
        effectiveness: {
            effective = [],
            global = [],
            not_effective = []
        } = {},
        total_licenses = 0,
        total_patients = 0
    } = licensesSummary;

    const licensesTable = [...TABLE, ...licensesConfig];

    const downloadController = {
        data: licensesDownload,
        downloading: licensesDownloading,
        fileName: t('Licencias'),
        headers: downloadHeaders.filter(({ hidden }) => !hidden),
        onDownload: filters => dispatch(statisticsActions.getStatisticsLicensesDownload(filters))
    };

    const defaultConfig = {
        dataKey: 'value',
        fontSize: 12,
        tickFormatter: ({ payload: { label, value } }) => `${ value.toFixed(1) }% ${ label }`
    };

    const globalConfig = {
        config: [{ ...defaultConfig, label: t('Licencias') }],
        data: global,
        height: 300,
        minWidth: 450
    };

    const effectiveConfig = {
        config: [{ ...defaultConfig, fontSize: '11px', label: t('Efectivas') }],
        data: effective.filter(({ value }) => !!value),
        height: 300,
        minWidth: 600,
        tooltip: true
    };
    
    const notEffectiveConfig = {
        config: [{ ...defaultConfig, fontSize: '11px', label: t('No efectivas') }],
        data: not_effective.filter(({ value }) => !!value),
        height: 300,
        minWidth: 600,
        tooltip: true
    };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterPatients={ ['area', 'cost_center', 'hr_head', 'patient', 'license_reason', 'position', 'workplace'] }
            loading={ loading }
            tabController={ tabController }
            title={ t('Licencias') }
            onFiltersChange={ onFiltersChange }
        >
            <Row>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Atenciones realizadas') }
                        icon="summarize"
                        title={ (total_licenses ?? 0).toString() }
                    />
                </Col>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Cantidad de pacientes') }
                        icon="people"
                        title={ (total_patients ?? 0).toString() }
                    />
                </Col>
                {
                    !!total_licenses &&
                    <>
                        <Col xs="12">
                            <Card overflowX="auto" >
                                <PieChart { ...globalConfig } />
                            </Card>
                        </Col>
                        <Col md="6" xs="12">
                            <Card overflowX="auto" title={ t('Efectivas') }>
                                <PieChart { ...effectiveConfig } />
                            </Card>
                        </Col>
                        <Col md="6" xs="12">
                            <Card overflowX="auto" title={ t('No efectivas') }>
                                <PieChart { ...notEffectiveConfig } />
                            </Card>
                        </Col>
                        <Col xs="12">
                            <Table
                                config={ licensesTable }
                                data={ licenses }
                            />
                        </Col>
                    </>
                }
            </Row>
        </StatisticsLayout>
    );
};

LicensesSummary.propTypes = {
    tabController: PropTypes.object
};

export default LicensesSummary;
